import { Box, Divider, Typography } from '@mui/material';
import { ContentFilterWidget } from './Widgets/ContentFilterWidget';
import { ProductFilterWidget } from './Widgets/ProductFilterWidget';
import { CategoryFilterWidget } from './Widgets/CategoryFilterWidget';

type SetFilterRequest = Models.SetsPlayground.SetFilterRequest;
type ContentMap = NonNullable<SetFilterRequest['content']>;
type ContentPropertyType = Models.SetsPlayground.ContentPropertyType;

interface FilterSectionProps {
    filter?: SetFilterRequest;
    onChangeFilter: (filter: SetFilterRequest) => void;
    showTitle?: boolean;
    productKey?: string;
    onChangeProductKey?: (key: string) => void;
    showApproximateResultWarning?: boolean;
    lockedContentKey?: ContentPropertyType;
    lockedContentHelperText?: string;
}

export const FilterSection = ({
    filter,
    onChangeFilter,
    showTitle = true,
    productKey,
    onChangeProductKey,
    showApproximateResultWarning: showApproximateWarning = false,
    lockedContentKey,
    lockedContentHelperText,
}: FilterSectionProps): JSX.Element => {
    const handleContentChange = (content: ContentMap): void => {
        const newFilter: SetFilterRequest = {
            ...filter,
            content,
        };

        onChangeFilter(newFilter);
    };

    const handleProductChange = (productOptions: Record<string, string[]>): void => {
        const newFilter: SetFilterRequest = {
            ...filter,
            product: { productOptions },
        };

        onChangeFilter(newFilter);
    };

    const handleCategoryChange = (category: string[][]): void => {
        const newFilter: SetFilterRequest = {
            ...filter,
            category,
        };

        onChangeFilter(newFilter);
    };

    return (
        <Box>
            {showTitle && (
                <>
                    <Typography fontWeight="medium" variant="body1">
                        Filters (optional)
                    </Typography>
                    <Divider />
                </>
            )}
            <ContentFilterWidget
                filter={filter}
                lockedHelperText={lockedContentHelperText}
                lockedKey={lockedContentKey}
                onChangeContent={(_index, content): void => handleContentChange(content)}
            />
            <Divider />
            <ProductFilterWidget
                filter={filter}
                productKey={productKey}
                showApproximateWarning={showApproximateWarning}
                onChangeProduct={(_index, productOptions): void => handleProductChange(productOptions)}
                onChangeProductKey={onChangeProductKey}
            />
            <Divider />
            <CategoryFilterWidget
                filter={filter}
                onChangeCategory={(_index, category): void => handleCategoryChange(category)}
            />
        </Box>
    );
};
